<template>
  <div id="shopdetail" class="ptop6">
    <remote-css :href="require('@/assets/mui/css/mui.css')"></remote-css>
    <remote-css :href="require('@/assets/app/css.css')"></remote-css>
    <remote-css :href="require('@/assets/mui/css/mui.css')"></remote-css>
    <remote-css :href="require('@/assets/mui/css/style.css')"></remote-css>
    <div class="detail_banner">
      <div class="swiper-container">
        <div id="slider" class="mui-slider">
          <div class="mui-slider-group mui-slider-loop">
            <!-- 额外增加的一个节点(循环轮播：第一个节点是最后一张轮播) -->
            <div class="mui-slider-item mui-slider-item-duplicate">
              <a href="">
               <img :src="model.imagelist[model.imagelist.length==0?0:model.imagelist.length-1]">
              </a>
            </div>

            <div class="mui-slider-item" v-for="item in model.imagelist">
              <a>
                <img :src="item">
              </a>
            </div>
            <!-- 额外增加的一个节点(循环轮播：最后一个节点是第一张轮播) -->
            <div class="mui-slider-item mui-slider-item-duplicate">
              <a href="">
                <img :src="model.imagelist[0]">
              </a>
            </div>
          </div>
          <div class="mui-slider-indicator" v-if="model.imagelist.length>1">
            <div class="mui-indicator mui-active" v-for="(item,index) in model.imagelist" v-if="index==0"></div>
            <div class="mui-indicator" v-for="(item,index) in model.imagelist" v-if="index!=0"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail_list">
      <h2>{{model.title}}</h2>
      <ul>
        <li class="iconfont">
           <a @click="gotel(model.phone)">
            <em>联系电话</em>
            <span><i class="iconfont icon-dianhua"></i>{{model.phone}} </span>
          </a>
        </li>
        <li class="iconfont">
          <a @click="gomap()">
            <em>联系地址</em>
            <span><i class="iconfont icon-icon-test5"></i>{{model.address}}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="detail3_ht"></div>
    <div class="mui-content bgcolor1 detail_box">
      <div class="detail_text">
        <h4>商家介绍</h4>
       <p v-html="model.content"></p>
      </div>
    </div>
	<div class="back_index">
		<router-link to="/" tag="div" class="btn">
			返回首页
		</router-link>
	</div>
  </div>
</template>

<script>
export default {
  name: 'Shopdetail',
  data () {
    return {
      model: {
        imagelist: []
      },
      shares: null,
      sweixin: null,
      buttons: [
        {title: '我的好友', extra: {scene: 'WXSceneSession'}},
        {title: '朋友圈', extra: {scene: 'WXSceneTimeline'}},
        {title: '我的收藏', extra: {scene: 'WXSceneFavorite'}}
      ]
    }
  },
  methods: {
    plusReady () {
      this.updateSerivces()
    },
    updateSerivces () {
      var that = this
      plus.share.getServices(function (s) {
        that.shares = {}
        for (var i in s) {
          var t = s[i]
          that.shares[t.id] = t
        }
        that.sweixin = that.shares['weixin']
      }, function (e) {
        console('获取分享服务列表失败：' + e.message)
      })
    },
    /**
       * 拨打电话
       */
    gotel (number) {
        location.href = 'tel:' + number
    },
    loadData () {
      var that = this
      if (this.$app.getParam('id')) {
        that.$wx.showLoading()
        this.$app.pr('/api/shopmerchuser/detail', {
          id: this.$app.getParam('id')
        }).then((res) => {
          that.$wx.hideLoading()
          if (res.success) {
            that.model = res.data
          } else {
            that.$wx.showToast('数据加载失败')
          }
        }).catch((res) => {
          that.$wx.hideLoading()
          that.$wx.showToast('加载失败')
        })
      }
    },
    gomap(){
        var that = this
        that.$wx.showLoading();
        this.$app.pr('/api/common/jsapi_openLocation',{
            url:that.$wx.getUrls()
        }).then((res) => {
            that.$wx.hideLoading();
            wx.config(res.data.shareparam);
            try{
                wx.ready(function(){
                    wx.openLocation({
                        latitude: that.model.lnglat_lat, // 纬度，浮点数，范围为90 ~ -90
                        longitude:that.model.lnglat_lng, // 经度，浮点数，范围为180 ~ -180。
                        name: that.model.title, // 位置名
                        address: that.model.address, // 地址详情说明
                        scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
                    });
                });
            }catch(e){
                that.$wx.hideLoading();
                alert('fx error'+e)
            }
        });
    }
  },
  created () {

  },
  mounted () {
    var that = this
    if (window.plus) {
      that.plusReady()
    } else {
      document.addEventListener('plusready', that.plusReady, false)
    }
    this.loadData()
    // 获得slider插件对象
    var gallery = mui('.mui-slider')
    gallery.slider({
      interval: 5000 // 自动轮播周期，若为0则不自动播放，默认为0；
    })
  }

}
</script>

<style scoped="scoped">
	#shopdetail{
		padding-bottom: calc(1rem + env(safe-area-inset-bottom));
	}
	.detail_box .detail_text{
		padding-bottom: 0;
	}
	.back_index{
		width: 100%;
		background-color: #fff;
		padding-bottom: env(safe-area-inset-bottom);
		position: fixed;
		bottom: 0;
		left: 0;
	}
	.back_index .btn{
		width: 100%;
		background-color: #2AAFFB;
		height: 1rem;
		text-align: center;
		line-height: 1rem;
		font-size: .3rem;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/Shopdetail.vue